import { useMemo } from "react";

import { useMediaQuery } from "@mui/material";
import TilleyDataGrid from "components/shared/DataGrid/TilleyDataGrid";
import { formatDate } from "utility/formatters";

export const MEMBER_ACTION_MANAGE_ACCOUNT = "manage_account";

export default function AgentUserGrantDataTable({
  userGrants,
  isLoading,
  pageSizes = [5, 10, 25, 50, 100],
  rowHeight = 80,
}) {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("lg"), { noSsr: true });

  const COLUMNS_MEMBERS = useMemo(
    () => [
      {
        field: "producer_description",
        headerName: "Name",
        flex: 4,
      },
      {
        field: "producer_email",
        headerName: "Email",
        flex: 1,
      },
      {
        field: "lastupdate",
        headerName: "Last Updated",
        flex: 1,
        valueGetter: (value) => formatDate(value),
      },
    ],
    []
  );

  return (
    <TilleyDataGrid
      rows={userGrants || []}
      columns={COLUMNS_MEMBERS}
      pageSizeOptions={pageSizes}
      defaultPageSize={isMobile ? 5 : 10}
      gridKey="agent-user-grants"
      getRowId={(row) => row.id}
      rowHeight={rowHeight}
      isLoading={isLoading}
      sx={{ maxWidth: "99%", boxSizing: "border-box" }}
    />
  );
}
